import React from "react";

const AdditionalCharges = ({ Additional, formData }) => {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Additional Charges</h3>
      <div className="max-w-full overflow-x-auto rounded-xl relative">
        <table className="min-w-full table-fixed text-sm text-left text-gray-500 dark:text-gray-400">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className={`px-6 py-3  `}>
                Description
              </th>
              <th scope="col" className={`px-6 py-3 `}>
                Note
              </th>
              <th scope="col" className={`px-6 py-3 `}>
                Amount (USD)
              </th>
            </tr>
          </thead>
          <tbody>
            {Additional?.map((items, index) => (
              <tr
                key={index}
                className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
              >
                <td className="px-6 py-4 ">{items?.Description}</td>
                <td className="px-6 py-4">{items?.Note}</td>
                <td className="px-6 py-4">$ {items?.Amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="text-lg font-semibold mt-5 text-right">
          Additional Charges: {" $ " + formData?.Aggregate_Field_1}
        </div>
      </div>
    </div>
  );
};

export default AdditionalCharges;
